export function htmlCommission() {
  return (
    <>
      <hr />
      <h5>Comissionamento</h5>
      <p>
        Trata-se de incentivos financeiros pela divulgação de Campanhas e demais
        atividades na Plataforma.
        <br />O proprietário da Campanha pode personalizar o seu percentual de
        comissão na venda de Tickets à seus indicados.
      </p>

      {/* Ticket Sale */}
      <h5 className="fw-bold">Ticket:</h5>
      <p>
        O proprietário define o valor de sua comissão e esta é repassada, como
        Entrada de Recursos, na venda de Tickets de sua Campanha. <br />
        Ex: O proprietário definiu que sua comissão será de 50% (cinquenta por cento) e cada
        Ticket esteja R$ 5,00 (cinco reais).
        <br />
        Quando um indicado efetuar, e confirmar, a compra, obterá uma Entrada de
        Recurso em sua conta no valor de R$ 2,50 (dois reais e cinquenta centavos).
      </p>
    </>
  );
}
